'use strict';

exports.__esModule = true;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports.default = function (element, props) {
  return new CSSRenderer(_extends({
    element: element,
    enableHardwareAcceleration: true
  }, props));
};
var _ = require('../');
var _2 = _interopRequireDefault(_);
var _render = require('./render');
var _render2 = _interopRequireDefault(_render);
var _transformProps = require('./transform-props');
var _transformProps2 = _interopRequireDefault(_transformProps);
var _valueTypes = require('./value-types');
var _valueTypes2 = _interopRequireDefault(_valueTypes);
var _prefixer = require('./prefixer');
var _prefixer2 = _interopRequireDefault(_prefixer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CSSRenderer = function (_Renderer) {
  _inherits(CSSRenderer, _Renderer);
  function CSSRenderer() {
    _classCallCheck(this, CSSRenderer);
    return _possibleConstructorReturn(this, _Renderer.apply(this, arguments));
  }
  CSSRenderer.prototype.onRender = function onRender() {
    var _props = this.props,
      element = _props.element,
      enableHardwareAcceleration = _props.enableHardwareAcceleration;
    (0, _render2.default)(element, this.state, this.changedValues, enableHardwareAcceleration);
  };
  CSSRenderer.prototype.onRead = function onRead(key) {
    var valueType = _valueTypes2.default[key];
    if (!_transformProps2.default[key]) {
      var element = this.props.element;
      var domValue = window.getComputedStyle(element, null)[(0, _prefixer2.default)(key)] || 0;
      return valueType && valueType.parse ? valueType.parse(domValue) : domValue;
    } else {
      if (valueType) {
        return valueType.default || 0;
      } else {
        return 0;
      }
    }
  };
  return CSSRenderer;
}(_2.default);